import { MotherStage } from '../../ArticlePage/RelatedArticlesNew/styled';
import { MotherName, UserImage, UserProfileSection } from './styled';

export default function UserProfile(props) {
  const { data } = props;
  return (
    <UserProfileSection>
      <UserImage src={data?.thumbImages} loading="lazy" alt="UserImage" />
      <div>
        <MotherName>{data?.username}</MotherName>
        <MotherStage>{data?.relation}</MotherStage>
      </div>
    </UserProfileSection>
  );
}
